import { render } from "./Dashboard.vue?vue&type=template&id=3cfaf703"
const script = {}

const cssModules = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=3cfaf703&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__